import { Box } from "@mui/material";

// components
import { TextFieldStr } from "../../ui/text-field";
import { CheckboxPlanner } from "../../ui/checkbox-planner";

// services & constants
import { TEXT } from "../../../constants/text";
import { useUserContext } from "../../../services/context/user-context";
import { usePlannerContext } from "../../../services/context/planner-context";

export const Carparking = ({ area, nodeId }) => {
  const { setNodes } = usePlannerContext();
  const { viewOnly } = useUserContext();
  const formValues = area.building;
  /*   const [parkingEmpty, setParkingEmpty] = useState(false);
  const [employeesEmpty, setEmployeesEmpty] = useState(false); */

  const handleValueChange = (value, name) => {
    setNodes((nodes) =>
      nodes.map((node) => {
        if (node.id === nodeId) {
          return {
            ...node,
            data: {
              ...node.data,
              building: {
                ...node.data.building,
                [name]: value,
              },
            },
          };
        }
        return node;
      })
    );
  };

  /*   useEffect(()=>{
    if(validateStart > 0){
      if(parkingEmpty && employeesEmpty){
        setErrors(prev => prev + 1);
      }
      setValidateEnd(prev => prev + 1);
    }
  }, [validateStart, parkingEmpty, employeesEmpty]) */

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        mt: "16px",
      }}
    >
      {/*  <CollapsedBox height={280}> */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        {/* <Box>
        <Typography fontSize={12}> Space Requirements *</Typography>
        <Typography fontSize={10} color="#e0e0e0"> Please provide at least one of the following fields:</Typography>
        </Box> */}
        {/*  <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: 'column',
          gap: "4px",
        }}
      >
      <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            gap: "4px",
          }}
        >
          <TextFieldStr
            label={"Nr. of Employees"}
            unit=""
            placeholder="alternative"
            name='numEmployees'
            value={formValues.numEmployees}
            setValue={handleValueChange}
            area={area}
            shouldBeInteger={true}
            setAlternativeInputsEmpty={setEmployeesEmpty}
            alternative={true}
            alternativeInputsEmpty={parkingEmpty && employeesEmpty}
          />
          <Typography mt={'33px'} fontSize={'12px'} color="#343745">or</Typography>

          <TextFieldStr
            label={"Nr. of Parkings"}
            unit=""
            placeholder="alternative"
            name='numParkingSlots'
            value={formValues.numParkingSlots}
            setValue={handleValueChange}
            area={area}
            shouldBeInteger={true}
            setAlternativeInputsEmpty={setParkingEmpty}
            alternative={true}
            alternativeInputsEmpty={parkingEmpty && employeesEmpty}
          />
        </Box>
        {validateStart > 0 && employeesEmpty && parkingEmpty && (
        <FormControl
        error={employeesEmpty && parkingEmpty}
        variant="standard"
        sx={{ width: "100%" }}
      >
        <FormHelperText sx={{ pl: "8px" }}>
            At least one of the fields must be filled.
          </FormHelperText>
      </FormControl>
          
        )}
      </Box>    */}

        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "top",
            justifyContent: "space-between",
            gap: "16px",
          }}
        >
          <TextFieldStr
            label={"Nr. of Parkings"}
            unit=""
            placeholder="mandatory"
            name="numParkingSlots"
            value={formValues.numParkingSlots}
            setValue={handleValueChange}
            area={area}
            shouldBeInteger={true}
            requier={true}
            tooltip="Specify the needed amount of car parking lots. The area is dimensioned for parallel parked cars by multiplying 19.2m2 with this value."
            disabled={viewOnly}
          />

          <TextFieldStr
            label={"max. Area"}
            unit="m²"
            placeholder="optional"
            name="rangeMax"
            value={formValues.rangeMax}
            setValue={handleValueChange}
            area={area}
            shouldBeInteger={false}
            tooltip="Define the maximum area for Car Parking Area."
            disabled={viewOnly}
          />
        </Box>

        <TextFieldStr
          label={"Cost per m²GFA"}
          unit="€/m²GFA"
          placeholder="optional"
          name="cost"
          value={formValues.cost}
          setValue={handleValueChange}
          area={area}
          tooltip={TEXT.planner.inputs.costTooltip}
          max={10000}
          disabled={viewOnly}
        />

        <CheckboxPlanner
          label={"Isolated"}
          value={formValues.isolated}
          setValue={handleValueChange}
          name="isolated"
          area={area}
          tooltip={
            "If this area shall be positioned in distance to the other required areas, tick the box."
          }
          disabled={viewOnly}
        />
      </Box>
      {/* </CollapsedBox> */}
    </Box>
  );
};
